module.exports = __webpack_public_path__ + "static/media/decender@2x.7f36b9b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mozilla/DesignTokens/Typescale/decender@2x.png
// module id = ./src/assets/Mozilla/DesignTokens/Typescale/decender@2x.png
// module chunks = 0